import { selectFormSubmissionById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { formSubmissionDetailViewStaticData } from "src/views/FormSubmissionDetailView/constants"
import { FormSubmissionDetailView } from "src/views/FormSubmissionDetailView/FormSubmissionDetailView"
import { NotFound } from "src/views/FormSubmissionDetailView/NotFound"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/")({
	component: FormSubmissionDetailView,
	notFoundComponent: NotFound,
	staticData: formSubmissionDetailViewStaticData,
	loader: ({ params }) => {
		const formSubmission = selectFormSubmissionById(params.formSubmissionId)(appStore.getState())
		if (!formSubmission) throw notFound()
	},
})
